export interface FileValidationResponse {
  isValid: boolean;
  errorMessage: string;
}

export const successfulFileValidationResponse: FileValidationResponse = {
  isValid: true,
  errorMessage: ''
};
